import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { AppleIcon, SmartphoneIcon } from 'lucide-react';
export function CtaSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  return <section ref={ref} id="download" className="relative py-32 px-6 overflow-hidden bg-gradient-to-br from-orange-500 to-orange-600" data-id="element-11">
      {/* Decorative elements */}
      <div className="absolute top-20 left-20 w-96 h-96 bg-white rounded-full blur-3xl opacity-10" data-id="element-12"></div>
      <div className="absolute bottom-20 right-20 w-64 h-64 bg-white rounded-full blur-3xl opacity-10" data-id="element-13"></div>

      {/* Sparkle decorations */}
      <div className="absolute top-10 right-1/4 text-white text-4xl opacity-30" data-id="element-14">
        ✦
      </div>
      <div className="absolute bottom-10 left-1/4 text-white text-5xl opacity-20" data-id="element-15">
        ✦
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.6
    }} className="relative max-w-4xl mx-auto text-center" data-id="element-16">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{
        fontFamily: 'DM Serif Display, serif'
      }} data-id="element-17">
          Ready to bring your family together?
        </h2>

        <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto" data-id="element-18">
          Download Famday today and start managing your family life with ease.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-19">
          <button className="bg-white text-orange-600 px-8 py-4 rounded-2xl font-semibold hover:bg-gray-50 transition-all hover:scale-105 flex items-center justify-center gap-3 shadow-xl" data-id="element-20">
            <AppleIcon className="w-6 h-6" data-id="element-21" />
            <div className="text-left" data-id="element-22">
              <div className="text-xs opacity-70" data-id="element-23">Download on the</div>
              <div className="text-lg font-bold" data-id="element-24">App Store</div>
            </div>
          </button>

          <div className="bg-white/20 text-white/60 px-8 py-4 rounded-2xl flex items-center justify-center gap-3 cursor-default" data-id="element-25">
            <SmartphoneIcon className="w-6 h-6" data-id="element-26" />
            <div className="text-left" data-id="element-27">
              <div className="text-xs opacity-80" data-id="element-28">Google Play</div>
              <div className="text-lg font-semibold" data-id="element-29">Coming Soon</div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}